export const currencies = {
  UAH: 'грн',
  USD: '$',
  EUR: '€',
};

export default currencies;
